import country from '@/config/countries.js';

export const TENANT_IDS = {
  BM_DEMO_GLOBAL: 'bmdemo-global',
  BM_DEMO_UK: 'bmdemo-uk',
  BM_DEMO_US: 'bmdemo-us',
  GLS_AT: 'gls-at',
  GLS_BE: 'gls-be',
  GLS_CA: 'gls-ca',
  GLS_CZ: 'gls-cz',
  GLS_DE: 'gls-de',
  GLS_DK: 'gls-dk',
  GLS_ES: 'gls-es',
  GLS_FR: 'gls-fr',
  GLS_HR: 'gls-hr',
  GLS_HU: 'gls-hu',
  GLS_IT: 'gls-it',
  GLS_NL: 'gls-nl',
  GLS_PL: 'gls-pl',
  GLS_RO: 'gls-ro',
  GLS_RS: 'gls-rs',
  GLS_SI: 'gls-si',
  GLS_SK: 'gls-sk',
  GLS_STUDIO_DE: 'glsstudio-de',
  GLS_US: 'gls-us',
  GLS_US_TEST: 'gls-us-test',
  ROYALMAIL_UK: 'royalmail-uk',
  ROYALMAIL_UK_TEST: 'royalmail-uk-test'
};

const tenant = (id, country, name, config) => ({
  ...{ id, name, country },
  ...config
});

export default Object.fromEntries(
  [
    tenant(TENANT_IDS.BM_DEMO_GLOBAL, country.US, 'Bettermile Demo Global', {
      gdprApproved: true
    }),
    tenant(TENANT_IDS.BM_DEMO_UK, country.UK, 'Bettermile Demo UK', {
      gdprApproved: true
    }),
    tenant(TENANT_IDS.BM_DEMO_US, country.US, 'Bettermile Demo US', {
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_AT, country.AT, 'GLS Austria', {
      hasAccessibilityReport: true,
      gdprApproved: false
    }),
    tenant(TENANT_IDS.GLS_BE, country.BE, 'GLS Belgique', {
      disableStopsComponent: true,
      hasAccessibilityReport: true,
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_CA, country.CA, 'GLS Canada', {
      hasAccessibilityReport: true,
      dayFormat: 'YYYY-MM-DD',
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_CZ, country.CZ, 'GLS Czech Republic', {
      hasAccessibilityReport: true,
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_DE, country.DE, 'GLS Germany', {
      hasAccessibilityReport: true,
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_DK, country.DK, 'GLS Denmark', {
      hasAccessibilityReport: true,
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_ES, country.ES, 'GLS Spain', {
      hasAccessibilityReport: true,
      disableFromAddress: true,
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_FR, country.FR, 'GLS France', {
      hasAccessibilityReport: true,
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_HR, country.HR, 'GLS Croatia', {
      hasAccessibilityReport: true,
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_HU, country.HU, 'GLS Hungary', {
      disableToAddress: true,
      hasAccessibilityReport: true,
      timeFormat: 'HH:mm',
      dayFormat: 'YYYY.MM.DD',
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_IT, country.IT, 'GLS Italia', {
      disableImprintLink: true,
      disableDepositPermission: true,
      disableDeliverToNeighbour: true,
      disableFromAddress: true,
      disableStopsComponent: true,
      hasAccessibilityReport: true,
      disableDriverDistance: true,
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_NL, country.NL, 'GLS Netherlands', {
      disableContactLink: true,
      disableImprintLink: true,
      postCodeTextInput: true,
      hasAccessibilityReport: true,
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_PL, country.PL, 'GLS Poland', {
      postCodeTextInput: true,
      hasAccessibilityReport: true,
      disableDriverDistance: true,
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_RO, country.RO, 'GLS Romania', {
      hasAccessibilityReport: true,
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_RS, country.RS, 'GLS Serbia', {
      hasAccessibilityReport: true,
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_SI, country.SI, 'GLS Slovenia', {
      hasAccessibilityReport: true,
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_SK, country.SK, 'GLS Slovakia', {
      hasAccessibilityReport: true,
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_STUDIO_DE, country.DE, 'NewCo (powered by Studio)', {
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_US, country.US, 'GLS US', {
      disableTrackingId: true,
      disableImprintLink: true,
      hasAccessibilityReport: true,
      timeFormat: 'hh:mm A',
      dayFormat: 'MM/DD/YYYY',
      gdprApproved: true
    }),
    tenant(TENANT_IDS.GLS_US_TEST, country.US, 'GLS US (QA)', {
      disableTrackingId: true,
      disableImprintLink: true,
      hasAccessibilityReport: true,
      isTestTenant: true,
      timeFormat: 'hh:mm A',
      dayFormat: 'MM/DD/YYYY',
      gdprApproved: true
    }),
    tenant(TENANT_IDS.ROYALMAIL_UK, country.UK, 'Royal Mail', {
      postCodeTextInput: true,
      dayFormat: 'DD/MM/YYYY',
      gdprApproved: true
    }),
    tenant(TENANT_IDS.ROYALMAIL_UK_TEST, country.UK, 'Royal Mail (QA)', {
      postCodeTextInput: true,
      dayFormat: 'DD/MM/YYYY',
      gdprApproved: true
    })
  ].map(tenant => [tenant.id, tenant])
);

export function isGlsTenant(tenantId) {
  return /^gls-/.test(tenantId);
}
